/**
 * @author xyguo
 * @description 远程评估详情页面配置
 * @Date  2021/7/19
 */
import React from "react";
import { connect } from "dva";
import { templateConfig, reduxTemplateCofig } from "./config";
import {modelUtils} from '@/utils'
import { component_tool, framework_tool,utils_tool } from '@/tool';
let { WizContainer, WizReduxTemplate, WizInputNumber } = framework_tool;
let { WizBrowserExport } = component_tool;
let {Session} = utils_tool;

class OrgRemoteEvaluationDetailList extends WizContainer {
  componentName = 'orgRemoteEvaluationDetailList';
  constructor(props) {
    super(props);
    this.state = {
    }
    this.keyforms = (new Date().getTime());
    const {history} = props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/remoteAuth/remoteAuthList/orgRemoteEvaluationDetailList') {
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        Session.set('orgRemoteEvaluationDetailRecord', initialValue)
      } else {
        initialValue = Session.get('orgRemoteEvaluationDetailRecord') || {};
      }
    }
    this.initialValue = initialValue;

  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: "检核场次",
        field: "name",
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: "检核项目",
        field: "remoteAuthName",
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '经销商简称',
        field: 'shortName',
        width: 15,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '经销商代码',
        field: 'dealerNumber',
        width: 15,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '检核时间',
        field: 'startToEndDateStr',
        width: 35,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
        },
      },
      {
        headerName: '检核终端',
        field: 'authWay',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '检核状态',
        field: 'authStateCh',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '讲师',
        field: 'lectureName',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '总得分',
        field: 'score',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '通过状态',
        field: 'passCh',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
    ]
    if (o['success']) {
      let data = o['data']

      let _data = []
      data && data.forEach(d => {
        let _d = { ...d }
        // let publishStateName = '';
        // switch (d.publishState) {
        //   case 0:
        //     publishStateName = "待更新";
        //     break;
        //   case 1:
        //     publishStateName = "可发布";
        //     break;
        //   case 2:
        //     publishStateName = "已发布";
        //     break;
        //   case 3:
        //     publishStateName = "未参考";
        //     break;
        // }
        // let authStateName = '';
        // switch (d.authState) {
        //   case 0:
        //     authStateName = "未开始";
        //     break;
        //   case 1:
        //     authStateName = "已开始";
        //     break;
        //   case 2:
        //     authStateName = "认证中";
        //     break;
        //   case 3:
        //     authStateName = "未参考";
        //     break;
        //   case 4:
        //     authStateName = "已完成";
        //     break;
        //   case 5:
        //     authStateName = "可回看";
        //     break;
        // }
        // if (_d.pass === 0) {
        //   _d.pass = '未通过'
        // } else if(_d.pass === 1){
        //   _d.pass = '通过'
        // }else{
        //   _d.pass =""
        // }
        // _d.publishStateName = publishStateName;
        // _d.authStateName = authStateName;
        // if ((!_d.score && _d.score != 0) || _d.score < 0) {
        //   _d.score = "";
        // }
        if(d.authStateCh=='认证中'){
          _d.authStateCh = '检核中'
        }
        if(d.authState!=4){
          _d.score = ""
        } 
        _d.authWay = d.authWay===0?'培训助手':'企业微信'
        _data.push(_d)
      });
      WizBrowserExport({
        title: '评估详情信息',
        sheetName: '评估详情信息',
        columns: columnDefs.filter((_, index) => index),
        rows: _data,
        filename: '评估详情信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleQUERY(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      this.keyforms = (new Date().getTime());
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let keyforms = this.keyforms;
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig,
      apiDataFormat: {
        list: this._handleQUERY,
        publishState: this._handleCMD,
        export: this._handleFile,
        updateAuthState : this._handleCMD,
      },
      remoteAuthId : this.initialValue.id,
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(OrgRemoteEvaluationDetailList);
